// features/drive/components/Search/Search.styles.js

import styled from 'styled-components';

export const SearchWrapper = styled.div`
  width: 320px;
  position: relative;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: ${({ theme }) => theme.landing.textSecondary};
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 42px;

  padding: 0 16px 0 42px;

  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};

  background: ${({ theme }) => theme.landing.background};

  color: ${({ theme }) => theme.landing.text};

  outline: none;

  &:focus {
    border-color: ${({ theme }) => theme.landing.buttonBg};
  }

  &::placeholder {
    color: ${({ theme }) => theme.landing.textSecondary};
  }
`;
